import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setCurrentStep } from '../../redux/Slices/InterviewSlice';
import {
  setCurrentSectionIndex,
  setIsOnBreak,
  setNextRound,
  setShowInstructions
} from '../../redux/Slices/StartTestSlice/startFulTest';
import { useAppSelector } from '../../redux/store/hooks';
import { getItem } from '../../utils/storage';
import InstructionsPage from '../Features/PracticeTest/Instructions/instructionsPage';

import Timer from './Timer';
const ModuleBreakTime = ({ nextR }: { nextR?: string }) => {
  const dispatch = useDispatch();
  const { currentSectionIndex, currentTime, isDriveTest, nextRound } =
    useAppSelector(state => state.root.startFulltest);
  const section = useAppSelector(
    state => state.root.newTemplete[0].rounds[0].sections
  );

  const handleClick = () => {
    const isLastSection = currentSectionIndex === section.length - 1;

    if (!isDriveTest) {
      if (section[currentSectionIndex].isInstructionAvailabe === true) {
        dispatch(setCurrentSectionIndex(currentSectionIndex + 1));
        dispatch(setShowInstructions(true));
      } else {
        dispatch(setCurrentSectionIndex(currentSectionIndex + 1));
      }
    } else {
      if (isLastSection) {
        dispatch(setNextRound(nextR));
        dispatch(setCurrentStep('instructions'));
      } else {
        if (section[currentSectionIndex].isInstructionAvailabe === true) {
          dispatch(setCurrentSectionIndex(currentSectionIndex + 1));
          dispatch(setShowInstructions(true));
        } else {
          dispatch(setCurrentSectionIndex(currentSectionIndex + 1));
        }
      }
    }
    dispatch(setIsOnBreak(false));
  };

  useEffect(() => {
    if (currentTime <= 0) {
      handleClick();
    }
  }, [currentTime, section, currentSectionIndex]);

  useEffect(() => {
    const handleBeforeUnload = (e: any) => {
      const message = 'Changes you made may not be saved.';
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div className='flex min-h-screen flex-col bg-[#FFFFFF]'>
      {currentTime <= 0 ? (
        <InstructionsPage />
      ) : (
        <>
          <div className='flex flex-1 flex-col items-center justify-center gap-4 p-4 text-center text-primary lg:gap-8 lg:p-8'>
            <div className='flex w-full flex-col items-center justify-center space-y-6 border-beta lg:space-y-8'>
              <div className='flex w-full max-w-[280px] flex-col rounded-2xl border-2 bg-alpha shadow-boxShadowOne transition-all duration-300 lg:max-w-[300px] lg:px-6 lg:py-3'>
                <div className='pb-3 text-center text-xs font-medium text-blue_a12 lg:text-lg'>
                  Remaining Break Time
                </div>
                <div className='text-center text-4xl font-semibold text-primary sm:text-5xl lg:text-5xl'>
                  <Timer />
                </div>
              </div>
            </div>

            <div className='flex w-full flex-col items-center px-4 lg:w-1/2 lg:items-start lg:px-12'>
              <h1 className='mb-1 self-center text-2xl font-medium text-blue_a12 lg:text-3xl'>
                Practice Test Break
              </h1>

              <p className='border-b-2 border-primary pb-4 text-lg font-medium'>
                You can resume this practice test as soon as you&apos;re ready
                to move on. On test day, you&apos;ll wait until the clock runs
                out. Read below to see how breaks work on test day.
              </p>

              <h2 className='my-4 self-center text-xl font-medium text-blue_a12 lg:text-2xl'>
                Take a Break: Do Not Close Your Device
              </h2>

              <p className='mb-4 self-center text-lg font-medium lg:text-base'>
                After the break, a Resume Testing Now button will appear and
                youll start the next session.
              </p>

              <div className='space-y-3 text-start lg:space-y-1'>
                <h3 className='text-lg font-medium lg:space-y-4 lg:text-xl'>
                  Break Rules:
                </h3>

                <ul className='list-disc space-y-1 pl-[30px] text-base font-normal lg:text-base'>
                  <li>
                    <span>Do not disturb students who are still testing</span>
                  </li>
                  <li>
                    <span>Do not exit the app or close your laptop</span>
                  </li>
                  <li>
                    <span>
                      Do not access phones, smartwatches, textbooks, notes, or
                      the internet
                    </span>
                  </li>
                  <li>
                    <span>Do not eat or drink near any testing device</span>
                  </li>
                  <li>
                    Do not speak in the test room; outside the test room, do not
                    discuss the exam with anyone
                  </li>
                </ul>
              </div>
              <button
                className='mt-6 w-full max-w-xs transform self-center rounded-lg bg-[#3F5DD9] px-6 py-3 text-sm font-normal text-[#FDFBF9] transition-all lg:mt-8 lg:text-base'
                onClick={() => handleClick()}
              >
                Continue to Next Section
              </button>
            </div>
          </div>

          <div className='flex h-auto w-full items-center justify-center p-4 text-lg font-bold text-white/90 lg:h-[10%] lg:justify-start lg:px-12 lg:text-2xl'>
            {getItem('userName')}
          </div>
        </>
      )}
    </div>
  );
};

export default ModuleBreakTime;
